import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { LocaleService } from "./shared/services/locale.service";
import { ThemeService } from "./shared/theme/theme.service";
import { Theme } from "./shared/theme/theme.model";
import { clientConfig } from "./shared/constant/app.constant";
import { SpinnerService } from "./shared/services/spinner.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent {
  title = "ClientApp";
  availableThemes: Theme[];
  activeThemeName: string = clientConfig.THEME;
  isLoading: boolean = true;
  languagesSupported: string[] = ["fr-FR", "es-ES", "pt-PT", "en-GB", "el-GR", "cs-CZ", "de-CH", "fr-BE", "fr-CH", "hu-HU", "it-CH", "nb-NO",
    "nl-BE", "ro-RO", "sk-SK", "tr-TR", "fi-FI", "da-DK", "de-AT", "de-DE", "nl-NL", "sv-SE"];

  constructor(
    private localeService: LocaleService,
    private themeService: ThemeService,
    private spinnerService: SpinnerService,
    private router: Router
  ) {
    spinnerService.show();
    for (let lang of this.languagesSupported) {
      this.localeService.registerCulture(lang);
    }

    this.themeService.setActiveThemeByName(clientConfig.THEME).finally(() => {
      // Finally block will be executed once the setActiveThemeByName method completes
      // Set loading to false to indicate that loading is complete
      this.isLoading = false;
    });
    this.availableThemes = this.themeService.getAvailableThemes();
  }

  changeTheme(event) {
    this.themeService.setActiveThemeByName(event.target.value);
  }

  ngOnInit() {
    this.router.navigate([""]);
    console.log(window.innerWidth);
  }
}
